"use client";

import { InfiniteScroll } from "@/components/core/InfiniteScroll/InfiniteScroll";
import { useFetchCommentReplies } from "@/hooks/blog/useFetchCommentReplies";
import { hasLoadedListItems } from "@/lib/pagination/hasLoadedListItems";
import { CommentItem, type CommentNode } from "./CommentItem";
import { CommentListSkeleton } from "./CommentListSkeleton";

interface CommentRepliesProps {
  commentId: string;
  slug: string;
  isLoggedIn: boolean;
  onRequireLogin: () => void;
}

export const CommentReplies: React.FC<CommentRepliesProps> = ({
  commentId,
  slug,
  isLoggedIn,
  onRequireLogin,
}) => {
  const query = useFetchCommentReplies(commentId, true);

  const listKey = ["blog-comment-replies", commentId, 20];

  const items: CommentNode[] =
    query.data?.pages.flatMap((p) => p?.data?.result ?? []) ?? [];

  if (query.isLoading && !hasLoadedListItems(query)) {
    return (
      <div className="mt-3 ms-4">
        <CommentListSkeleton />
      </div>
    );
  }

  return (
    <div className="mt-3 ms-4 space-y-4 border-s border-stroke-light/40 ps-3">
      {items.map((r) => (
        <CommentItem
          key={r.id}
          comment={r}
          slug={slug}
          listKey={listKey}
          isReply
          isLoggedIn={isLoggedIn}
          onRequireLogin={onRequireLogin}
        />
      ))}
      <InfiniteScroll query={query} />
    </div>
  );
};
